"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var dotsColoredStyle_1 = __importDefault(require("./dotsColoredStyle"));

var classnames_1 = __importDefault(require("classnames"));

exports.default = dotsColoredStyle_1.default(function (_a) {
  var classes = _a.classes,
      className = _a.className,
      style = _a.style;
  return react_1.default.createElement("div", {
    className: classnames_1.default(classes.loader, className),
    style: __assign({
      height: '1em'
    }, style)
  }, react_1.default.createElement("div", null), react_1.default.createElement("div", null), react_1.default.createElement("div", null), react_1.default.createElement("div", null));
});